import { Injectable } from '@angular/core';
import { DocumentRefService } from '@app/core/services/helpers/document-ref.service';
import { Color } from '../models/color.model';

@Injectable()
export class ColorService {
    constructor(private documentRefService: DocumentRefService) {}

    getColor(hexColor: string): Color {
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hexColor = hexColor.replace(
            shorthandRegex,
            function (_m: string, r: string, g: string, b: string) {
                return `#${r}${r}${g}${g}${b}${b}`;
            }
        );

        const regex = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i;
        const rgb = regex.exec(hexColor);
        const rgbValues = {
            red: parseInt(rgb[1], 16),
            green: parseInt(rgb[2], 16),
            blue: parseInt(rgb[3], 16),
        };

        return {
            hex: hexColor,
            rgb: `rgb(${rgbValues.red}, ${rgbValues.green}, ${rgbValues.blue})`,
            rgbValues,
        };
    }

    getColorFromStyles(cssVariable: string, defaultValue: string): string {
        return (
            getComputedStyle(this.documentRefService.documentElement)
                .getPropertyValue(cssVariable)
                .trim() ||
            getComputedStyle(this.documentRefService.documentElement)
                .getPropertyValue(defaultValue)
                .trim() ||
            '#fff'
        );
    }
}
